import ReactVisibilitySensor from "react-visibility-sensor";
import ArrowHead from '../../assets/icons/matrix-icons/arrow-head.svg';
import { useContext } from "react";
import { LangContext } from "../../App";

type MatrixCol = {
    type : string;
    content : string | null;
    icon : string | null;
}

type MatrixProps = {
    data : {
        matrix :  MatrixCol[][];
        yAxis : {
            label : string;
        };
        xAxis : {
            label : string;
        };
        levels : string[],
        keys : { icon : string, text : string }[],
    },
}

const Matrix = ({ data } : MatrixProps) => {
    const {lang} = useContext(LangContext)

  return (
    <>
    <div className={`matrix-container ${lang ? "rtl" : ""}`}>
        <div className="matrix-wrapper">
            <div className="y-axis">
                <p className="red-text">{data.yAxis.label}</p>
            </div>
            <div className="x-axis">
                <p className="red-text">{data.xAxis.label}</p>
            </div>
            <div className="levels-top">
                {data.levels.map((item, index) => (
                    <span className={`level level-${index}`}>{item}</span>
                ))}
            </div>
            <div className="levels-left">
                {data.levels.map((item, index) => (
                    <span className={`level level-${index}`}>{item}</span>
                ))}
            </div>
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
            <div className="matrix">
                {data.matrix.map((row, index) => (
                    <div key={index} className="m-row">
                        {row.map((col, indexTwo) => (
                            <div 
                                className={`m-col bg-${col.type} an-flip-x ${isVisible ? "an-active" : ""}`}
                                style={{ animationDelay : `${(data.matrix.length - index) * indexTwo / 30}s`}}
                                key={`${index}-${indexTwo}`}
                            >
                                {col.icon ? 
                                <img 
                                    title={col.content || "none"} 
                                    src={require(`../../assets/icons/matrix-icons/${col.icon}`)} 
                                    className="m-icon" 
                                /> 
                                : ""}
                                {col.content ? 
                                <span>{col.content}</span> 
                                : ""}
                            </div>
                        ))}
                    </div>
                ))}
                <img 
                    src={ArrowHead}
                    alt=""
                    className="arrow-head head-top"
                />
                <img 
                    src={ArrowHead}
                    alt=""
                    className="arrow-head head-right"
                />
            </div>  
            )}
            </ReactVisibilitySensor>
        </div>

    </div>
    <ReactVisibilitySensor
        partialVisibility
    >
    {({isVisible} : any) => (
        <div className="keys-map">
            {data.keys.map((item, index) => (
                <div key={index} className={`map-key an-pop-up an-d-${index + 1} ${isVisible ? "an-active" : ""}`}>
                    <span className="icon">
                        <img src={require(`../../assets/icons/matrix-icons/${item.icon}`)} alt="" />
                    </span>
                    <span className="text">{item.text}</span>
                </div>
            ))}
        </div>
    )}
    </ReactVisibilitySensor>
    </>
  )
}

export default Matrix